import { fetch } from "../../../appContainer";
import {
  GET_CONTAINERS_LIST_IN_PROGRESS,
  GET_CONTAINERS_LIST_SUCCESS,
  GET_CONTAINERS_LIST_FAIL,
  GET_CONTAINERS_LIST_FILTERS_IN_PROGRESS,
  GET_CONTAINERS_LIST_FILTERS_SUCCESS,
  GET_CONTAINERS_LIST_FILTERS_FAIL,
  GET_CONTAINERS_LIST_COUNT_IN_PROGRESS,
  GET_CONTAINERS_LIST_COUNT_SUCCESS,
  GET_CONTAINERS_LIST_COUNT_FAIL,
  GET_CONTAINERS_LIST_TOTAL_LOAD_IN_PROGRESS,
  GET_CONTAINERS_LIST_TOTAL_LOAD_SUCCESS,
  GET_CONTAINERS_LIST_TOTAL_LOAD_FAIL,
} from "../constants";

export function getContainersList(filters = {}) {
  return (dispatch) => {
    dispatch({ type: GET_CONTAINERS_LIST_IN_PROGRESS });

    fetch("api").getContainersList(
      filters,
      (list) => {
        dispatch({ type: GET_CONTAINERS_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_CONTAINERS_LIST_FAIL }),
    );
  };
}

export function getContainersListFilters() {
  return (dispatch) => {
    dispatch({ type: GET_CONTAINERS_LIST_FILTERS_IN_PROGRESS });

    fetch("api").getContainersListFilters(
      (filters) => {
        dispatch({
          type: GET_CONTAINERS_LIST_FILTERS_SUCCESS,
          payload: { filters },
        });
      },
      () => dispatch({ type: GET_CONTAINERS_LIST_FILTERS_FAIL }),
    );
  };
}

export function getContainersListCount(filters) {
  return (dispatch) => {
    dispatch({ type: GET_CONTAINERS_LIST_COUNT_IN_PROGRESS });

    fetch("api").getContainersListCount(
      filters,
      (count) => {
        dispatch({
          type: GET_CONTAINERS_LIST_COUNT_SUCCESS,
          payload: { count },
        });
      },
      () => dispatch({ type: GET_CONTAINERS_LIST_COUNT_FAIL }),
    );
  };
}

export function getContainersListTotalLoad(filters) {
  return (dispatch) => {
    dispatch({ type: GET_CONTAINERS_LIST_TOTAL_LOAD_IN_PROGRESS });

    fetch("api").getContainersListTotalLoad(
      filters,
      (totalLoad) => {
        dispatch({
          type: GET_CONTAINERS_LIST_TOTAL_LOAD_SUCCESS,
          payload: { totalLoad },
        });
      },
      () => dispatch({ type: GET_CONTAINERS_LIST_TOTAL_LOAD_FAIL }),
    );
  };
}
